interface CareerConnectionSuccessMessageProps {
  message: string;
  url: string;
}

const MyListMessage: React.FC<CareerConnectionSuccessMessageProps> = ({
  message,
  url,
}) => {
  return (
    <p>
      {message}{' '}
      <a className="underline" href={url}>
        your list!
      </a>
    </p>
  );
};

export default MyListMessage;
